import axios from 'axios';
import { BASE_URL, GOOGLE_API_KEY, OPEN_API } from './config';

export const updateLocation = (session_id, lat, long, from, ip = null) => {
  let location;
  let address = null;
  let street_num = null;
  let street = null;
  let city = null;
  let state = null;
  let state_code = null;
  let country = null;
  let country_code = null;
  let post_code = null;

  axios
    .get(
      'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
        lat +
        ',' +
        long +
        '&key=' +
        GOOGLE_API_KEY
    )
    .then((response) => {
      if (response.data.results.length > 0) {
        location = response.data.results[0];
        address =
          location.formatted_address !== '' ? location.formatted_address : null;
        const components = location.address_components || [];

        for (let i = 0; i < components.length; i++) {
          const com = components[i];
          const type = com.types && com.types.length > 0 ? com.types[0] : false;
          if (!type) {
            continue;
          }
          switch (type) {
            case 'street_number':
              street_num = com.long_name || null;
              break;
            case 'route':
              street = com.long_name || null;
              break;
            case 'locality':
              city = com.long_name || null;
              break;
            case 'administrative_area_level_2':
              if (!city || city === null) {
                city = com.long_name || null;
              }
              break;
            case 'administrative_area_level_1':
              state = com.long_name || null;
              state_code = com.short_name || null;
              break;
            case 'country':
              country = com.long_name || null;
              country_code = com.short_name || null;
              break;
            case 'postal_code':
              post_code = com.long_name || null;
              break;
            default:
              break;
          }
        }
      }

      const payload = {
        address,
        latitude: lat,
        longitude: long,
        street_num,
        street,
        city,
        state,
        state_code,
        country,
        country_code,
        post_code,
        ip
      };

      return axios
        .post(`${OPEN_API}v2/capture/sessions/${session_id}/locations`, payload, {
          headers: { 'Content-Type': 'application/json' },
        })
        .catch((error) => {
          console.log('====================================');
          console.log('location error', error);
          console.log('====================================');
          // TODO: Handle error
          // updateLocation(session_id, lat, long, from);
        });
    });
};
